module.exports = __webpack_public_path__ + "static/media/sessionIndicator.b6217122.svg";